




















































































































import { Component, Inject } from "vue-property-decorator";

import MagicValidator from "../../../magic/MagicValidator.vue";
import WidgetBase from "../WidgetBase";
import { SzgcModelView } from "../../../../model-view/index";

@Component({
  name: "SelectViewWidget",
  components: { MagicValidator, SzgcModelView}
})
export default class SelectViewWidget
  extends WidgetBase
{
  private modalShow: boolean = false;
  private proDetailShow: boolean = false;
  private processDetail: {businessId?: string} = {}

  get list() {
    return JSON.parse(this.value || "[]");
  }

  get text() {
    return this.list.map((i: any) => i.label).join("、")
  }

  get tableKey() {
    const val = JSON.parse(this.widget.property.configValue).value.split(":")
    return val[1]
  }

  getViewList({data}: {data: any}) {
    this.value = JSON.stringify(data || []);
    this.modalShow = false;
  }

  delItem(item: any) {
    const temp = JSON.parse(this.value);
    temp.some((i: any, index: number, arr: any[]) => i.businessId === item.businessId && arr.splice(index, 1));

    this.value = JSON.stringify(temp);
  }

  clickHandler(item: any) {
    this.processDetail = { businessId: item.businessId };
    this.proDetailShow = true;
  }

  @Inject({ from: "client", default: "web" })
  private client!: "web" | "mobile";
}
